module.exports = __webpack_public_path__ + "static/media/conbu.40df295b.png";